import { techDocs } from "../technical-docs";

export default techDocs('tech_standards', 'Normas Técnicas', 'documentos-tecnicos-normas-tecnicas')